module.exports = __webpack_public_path__ + "img/contactSupport.17061993.jpg";